import "./work-genie.css";
import OurWorksSection from "../../../components/our-works-section/OurWorksSection";

function WorkGenie() {
  const id = 6

  return (
    <div className="work genie">
      {/* Work Header */}
      <div className="work-header">
        <div className="work-branding">
          <div className="work-branding-title">
            <div className="work-branding-title-col-1">
              {window.innerWidth <= 768 ?
                <img
                  src="/assets/icons/partner-companies-logos/genie.svg"
                  alt="Genie Logo"
                /> :
                <h2
                  className="animate__animated animate__fadeIn animate__slow"
                  style={{ color: "#FF4963" }}
                >
                  <span>GENIE - </span> Social Network
                </h2>
              }
              {window.innerWidth <= 768 ?
                <h2
                  className="animate__animated animate__fadeIn animate__slow"
                  style={{ color: "#FF4963" }}
                >
                  <span>GENIE - </span> Social Network
                </h2>
                :
                <button
                  onClick={() => window.open("", "_blank")}
                >
                  Discover
                  &nbsp;
                  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} viewBox="0 0 12 12" fill="none">
                    <g clipPath="url(#clip0_272_603)">
                      <path
                        d="M5 3V4H2.5V9.5H8V7H9V10C9 10.1326 8.94732 10.2598 8.85355 10.3536C8.75979 10.4473 8.63261 10.5 8.5 10.5H2C1.86739 10.5 1.74021 10.4473 1.64645 10.3536C1.55268 10.2598 1.5 10.1326 1.5 10V3.5C1.5 3.36739 1.55268 3.24021 1.64645 3.14645C1.74021 3.05268 1.86739 3 2 3H5ZM10.5 1.5V5.5H9.5V3.2065L5.6035 7.1035L4.8965 6.3965L8.7925 2.5H6.5V1.5H10.5Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_272_603">
                        <rect width={12} height={12} fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              }
            </div>
            <div
              className={`work-branding-title-col-2  ${window.innerWidth <= 768 ? "d-none" : ""
                }`}
            >
              <img
                src="/assets/icons/partner-companies-logos/genie.svg"
                alt="Genie Logo"
              />
            </div>
          </div>
          <h1
            className={`animate__animated animate__fadeIn animate__slow ${window.innerWidth <= 768 ? "d-none" : ""
              }`}
          >
            These fun platforms let people share, create together, and chat about content.
          </h1>
        </div>

        <div className="work-main-img">
          <img
            src="/assets/images/work-pages/genie/genie-1.webp"
            alt="Work Image"
          />

          <div
            className={`work-main-img-content`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={100}
              height={100}
              viewBox="0 0 100 100"
              fill="none"
            >
              <rect width={100} height={100} rx={30} fill="white" />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M62.4715 40.1378C63.8154 44.887 62.4412 50.2003 58.496 53.688C53.0112 58.537 44.634 58.0215 39.785 52.5367C36.6082 48.9433 35.734 44.1085 37.0511 39.8376C32.4292 45.7745 32.5357 54.3436 37.7003 60.1855C43.5342 66.7844 53.613 67.4046 60.212 61.5707C66.4608 56.0464 67.3485 46.7157 62.4715 40.1378Z"
                fill="#FF4963"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M38.1077 63.8629C36.1296 59.3409 36.7675 53.89 40.2011 49.8974C44.9746 44.3468 53.344 43.7169 58.8946 48.4904C62.5311 51.6178 64.0556 56.2887 63.332 60.6992C67.1027 54.1883 65.8305 45.7134 59.9185 40.6291C53.2404 34.886 43.171 35.6439 37.4278 42.322C31.9894 48.6457 32.3805 58.0104 38.1077 63.8629Z"
                fill="#FF4963"
              />
            </svg>
            <h1>Genie Lite</h1>

            <div className="work-main-img-content-heading">
              <h1>Make rememberable Moments</h1>
              <div className="d-flex align-items-center justify-content-center">
                <h1>Each day</h1>
              </div>
            </div>
          </div>

          <div className="work-main-img-content-gradient"></div>
        </div>

        <h1 className={`${window.innerWidth > 768 ? "d-none" : ""}`}>
          These fun platforms let people share, create together, and chat about content.
        </h1>

        <button
          className={`${window.innerWidth > 768 ? "d-none" : ""}`}
          onClick={() => window.open("", "_blank")}
        >
          Discover
          &nbsp;
          <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} viewBox="0 0 12 12" fill="none">
            <g clipPath="url(#clip0_272_603)">
              <path
                d="M5 3V4H2.5V9.5H8V7H9V10C9 10.1326 8.94732 10.2598 8.85355 10.3536C8.75979 10.4473 8.63261 10.5 8.5 10.5H2C1.86739 10.5 1.74021 10.4473 1.64645 10.3536C1.55268 10.2598 1.5 10.1326 1.5 10V3.5C1.5 3.36739 1.55268 3.24021 1.64645 3.14645C1.74021 3.05268 1.86739 3 2 3H5ZM10.5 1.5V5.5H9.5V3.2065L5.6035 7.1035L4.8965 6.3965L8.7925 2.5H6.5V1.5H10.5Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_272_603">
                <rect width={12} height={12} fill="white" />
              </clipPath>
            </defs>
          </svg>
        </button>
      </div>

      {/* Work Desc Section */}
      <div className="work-desc-section">
        <div className="work-desc">
          <p>
            Not every social media app that hits the market is going to go
            viral. However, there are a few things you can do to nudge it in the
            right direction.
          </p>
          <p className={`${window.innerWidth <= 768 ? "d-none" : ""}`}>
            One of the first things you should consider during the Ideation
            process of building your app is its User Interface (UI). In other
            words, the means by which users interact with software. An app’s UI
            incorporates several elements, the content and media layout, input
            controls, navigation, and more.
          </p>
        </div>
        <div
          className={`work-provided-services ${window.innerWidth <= 768 ? "d-none" : ""
            }`}
        >
          <h2>Services we provided</h2>
          <ul>
            <li>Analytic Driven Iterations</li>
            <li>Market Research</li>
            <li>Wireframing</li>
            <li>UI/UX Design</li>
            <li>Motion Design</li>
            <li>Mobile App Design</li>
          </ul>
        </div>
      </div>

      {/* Work Section 1 */}
      <div className="work-section-1">
        <h1 className={`${window.innerWidth <= 768 ? "d-none" : ""}`}>Key Essential Features of a Social Media App</h1>
        <img
          src="/assets/images/work-pages/genie/genie-2.webp"
          alt="Work Image"
        />

        <div
          className={`work-provided-services ${window.innerWidth > 768 ? "d-none" : ""
            }`}
        >
          <h2>Services we provided</h2>
          <ul>
            <li>Analytic Driven Iterations</li>
            <li>Market Research</li>
            <li>Wireframing</li>
            <li>UI/UX Design</li>
            <li>Motion Design</li>
            <li>Mobile App Design</li>
          </ul>
        </div>

        <p className={`${window.innerWidth > 768 ? "d-none" : ""}`} >
          One of the first things you should consider during the Ideation
          process of building your app is its User Interface (UI). In other
          words, the means by which users interact with software. An app’s UI
          incorporates several elements, the content and media layout, input
          controls, navigation, and more.
        </p>
      </div>

      {/* Work Section 2 */}
      <div className="work-section-2">
        <h1>Visually Appealing and Accessible Design</h1>
        <p className={`${window.innerWidth <= 768 ? "d-none" : ""}`}>
          Many times, new social media applications fail to gain users because
          they are poorly designed. They may have a bunch of random,
          inconsistent elements that do not mesh well and create a sensory
          overload for users, preventing it from being accessible to everyone.
          Just like any other application, a social media app should have
          a consistent, accessible, and seamless design with fonts and color
          schemes that are carefully chosen to promote a cohesive and pleasant
          User Experience.
        </p>
        <p className={`${window.innerWidth <= 768 ? "d-none" : ""}`}>
          A key feature of social media apps is the ability to create a unique
          user account with personal login settings and identification methods
          that allow users to provide their name, contact information, location,
          occupation, and other personal data to the extent they choose as well
          as multiple verification methods for logging in, such as a backup
          email or code authentication.
        </p>
        <p className={`${window.innerWidth <= 768 ? "d-none" : ""}`}>
          Content sharing is one of the best social media app features because
          it facilitates communication between people and lets users feel more
          connected, even when they are far away from each other.
        </p>
        <img
          src="/assets/images/work-pages/genie/genie-3.webp"
          alt="Work Image"
        />
        <div className="d-flex justify-content-center">
          <img
            src="/assets/images/work-pages/genie/genie-4.webp"
            alt="Work Image"
          />
          <img
            src="/assets/images/work-pages/genie/genie-5.webp"
            alt="Work Image"
          />
        </div>

        <p className={`${window.innerWidth > 768 ? "d-none" : ""}`}>
          Many times, new social media applications fail to gain users because
          they are poorly designed. They may have a bunch of random,
          inconsistent elements that do not mesh well and create a sensory
          overload for users, preventing it from being accessible to everyone.
          Just like any other application, a social media app should have
          a consistent, accessible, and seamless design with fonts and color
          schemes that are carefully chosen to promote a cohesive and pleasant
          User Experience.
        </p>
        <p className={`${window.innerWidth > 768 ? "d-none" : ""}`}>
          A key feature of social media apps is the ability to create a unique
          user account with personal login settings and identification methods
          that allow users to provide their name, contact information, location,
          occupation, and other personal data to the extent they choose as well
          as multiple verification methods for logging in, such as a backup
          email or code authentication.
        </p>
        <p className={`${window.innerWidth > 768 ? "d-none" : ""}`}>
          Content sharing is one of the best social media app features because
          it facilitates communication between people and lets users feel more
          connected, even when they are far away from each other.
        </p>
      </div>

      {/* Work Section 3 */}
      <div className="work-section-3">
        <h1>The Results</h1>
        <img
          className={`${window.innerWidth > 768 ? "d-none" : ""}`}
          src="/assets/images/work-pages/genie/genie-6.webp"
          alt="Work Image"
        />
        <h2>
          #1: Easygoing and Friendly UI <br />
          #2: Eye-Catching and User-Friendly Design <br />
          #3: Safe and Secure Login   <br />
          #4: Social Networking Features <br />
          #5: Fun Content Sharing Options  <br />
          #6: Chat System <br />
          #7: Open Discussion Forum <br />
          #8: Personalizable Privacy Settings
        </h2>
        <img
          className={`${window.innerWidth <= 768 ? "d-none" : ""}`}
          src="/assets/images/work-pages/genie/genie-6.webp"
          alt="Work Image"
        />
      </div>

      <OurWorksSection workPageId={id} />
    </div>
  );
}

export default WorkGenie;
